import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Product} from "../../../../model/product";
import {ProductValueFormComponent} from "../../products-container/product-value-form/product-value-form.component";
import ProductUtils from "../../../../utils/product-utils";
import {Property} from "../../../../model/property";

@Component({
  selector: 'app-research-department-information',
  templateUrl: './research-department-information.component.html',
  styleUrls: ['./research-department-information.component.css']
})
export class ResearchDepartmentInformationComponent implements OnInit {

  researchDepartmentProduct: Product;
  selectedProperty: Property;
  @ViewChild(ProductValueFormComponent) productValueFormComponent: ProductValueFormComponent;
  protected readonly ProductUtils = ProductUtils;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private readonly dialogRef: MatDialogRef<ResearchDepartmentInformationComponent>) {}

  /**
   * Initializes the component:
   * - Sets the first product from the dialog data as 'researchDepartmentProduct'
   * - Sets the selected property from the dialog data
   */
  ngOnInit(): void {
    this.researchDepartmentProduct = this.data?.products?.[0] ?? undefined;
    this.selectedProperty = this.data?.selectedProperty ?? undefined;
  }

  /**
   * Closes the dialog, passing 'false' to indicate cancellation
   */
  public cancelModal(): void{
    this.dialogRef.close(false);
  }

  /**
   * Validates the product value form of the product value form component (if it exists) and closes the modal.
   * The modal will not close, if the form is not valid
   */
  public submitModal(): void {
    // 'isProductValueFormValid' automatically marks invalid inputs
    if(this.productValueFormComponent && !this.productValueFormComponent.isProductValueFormValid()){
      return;
    }
    this.dialogRef.close(true);
  }
}
